import React, { useEffect, useRef } from 'react';

export function scheduleIdTokenRefresh(idToken, email, onRefresh) {
  const { exp } = JSON.parse(atob(idToken.split('.')[1]));   // seconds
  const millisUntilExpiry = exp * 1000 - Date.now();
  const early = 60_000;                                      // refresh 1 min early
  const delay = Math.max(millisUntilExpiry - early, 5_000);  // never <5 s

   return setTimeout(() => {
     /* re-initialise for a silent refresh of *this* account only */
     window.google.accounts.id.initialize({
       client_id : process.env.REACT_APP_GOOGLE_CLIENT_ID,
       login_hint: email,               // ← pre-select same user
       auto_select: true,
       callback  : ({ credential }) => {
         if (credential) onRefresh(credential);
         else console.warn('Silent re-sign-in failed; user interaction needed');
       },
     });
     window.google.accounts.id.prompt();   // runs silently if session is valid
   }, delay);
}

/**
 * Renders the GIS button and calls `onSuccess(idToken, profile)`
 * when the user signs in.
 */
export default function GoogleLogin({ onSuccess }) {
  const btnRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    let script = document.querySelector('script[data-google-gsi]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client?hl=en';
      script.async = true;
      script.defer = true;
      script.dataset.googleGsi = 'true';
      document.body.appendChild(script);
    }

    const mount = () => {
      if (cancelled || !window.google?.accounts?.id || !btnRef.current) return;
      //window.google.accounts.id.disableAutoSelect();
      
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        // Optional Google Workspace domain hint; server-side ALLOWED_DOMAINS is the real gate
        ...(process.env.REACT_APP_HOSTED_DOMAIN ? { hosted_domain: process.env.REACT_APP_HOSTED_DOMAIN } : {}),
        auto_select : false,  // Don't auto-select, let user explicitly click
        callback: ({ credential: idToken }) => {
          const payload = JSON.parse(atob(idToken.split('.')[1]));
          onSuccess(idToken, {
            name: payload.name,
            email: payload.email,
            picture: payload.picture,
          });
        },
        ux_mode: 'popup',
      });

      // Don't auto-prompt - user must click the button

      window.google.accounts.id.renderButton(btnRef.current, {
        theme: 'outline',
        size: 'large',
        text: 'signin_with',
        locale: 'en',
      });
    };

    if (window.google?.accounts?.id) {
      mount();
    } else {
      script.addEventListener('load', mount);
    }

    return () => {
      cancelled = true;
      script.removeEventListener('load', mount);
    };
  }, [onSuccess]);

  return (
    <section className="centered">
      <h2>Please sign in</h2>
      <div ref={btnRef} id="g-btn"></div>
    </section>
  );
}